export default __webpack_public_path__ + "static/media/holycross.8edaf959.jpg";